import { render } from "./PAddBg.vue?vue&type=template&id=282af468"
import script from "./PAddBg.vue?vue&type=script&lang=js"
export * from "./PAddBg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__